import type { ComponentProps } from "react"
import { cn } from "@holigral/shared/ui/lib/utils"

export function Prose({ className, ...props }: ComponentProps<"div">) {
  return (
    <div
      // Themed in globals.css against the foundation's tokens, which is also
      // where the reading size lives — hence no `prose-sm`/`prose-base` pair
      // here, and no `prose-neutral`/`dark:prose-invert` one either.
      className={cn("prose prose-headings:font-heading", className)}
      {...props}
    />
  )
}

export function H1({ children, className, ...props }: ComponentProps<"h1">) {
  return (
    <Prose className={className}>
      <h1 {...props} className="mb-4!">
        {children}
      </h1>
    </Prose>
  )
}

export function H2({ children, className, ...props }: ComponentProps<"h2">) {
  return (
    <Prose className={className}>
      <h2 {...props}>{children}</h2>
    </Prose>
  )
}
